module.exports = __webpack_public_path__ + "static/media/mas.656a991d.svg";